// src/utils/youtubeUtils.js
const API_KEY = process.env.REACT_APP_YOUTUBE_API_KEY;

// Shorts are traditionally <= 60s. YouTube has since allowed up to 3 min
// in some cases — bump this to 180 if longer verticals are slipping through.
const SHORTS_MAX_DURATION_SECONDS = 200;

const parseISO8601Duration = (duration) => {
  const match = duration?.match(/PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/) || [];
  const hours = parseInt(match[1] || 0, 10);
  const minutes = parseInt(match[2] || 0, 10);
  const seconds = parseInt(match[3] || 0, 10);
  return hours * 3600 + minutes * 60 + seconds;
};

// videos.list accepts max 50 IDs per call, so batch just in case
const fetchVideoDurations = async (videoIds) => {
  const durations = {};

  for (let i = 0; i < videoIds.length; i += 50) {
    const batch = videoIds.slice(i, i + 50);
    const res = await fetch(
      `https://www.googleapis.com/youtube/v3/videos?part=contentDetails&id=${batch.join(',')}&key=${API_KEY}`
    );
    const data = await res.json();
    (data.items || []).forEach(item => {
      durations[item.id] = parseISO8601Duration(item.contentDetails?.duration);
    });
  }

  return durations;
};

export const fetchChannelVideos = async (uploadsId, limit = 18) => {
  // Fetch extra since filtering out Shorts will remove some results.
  // Bump the multiplier if your channel posts a lot of Shorts.
  const fetchCount = Math.min(limit * 2, 50);

  const res = await fetch(
    `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&playlistId=${uploadsId}&maxResults=${fetchCount}&key=${API_KEY}`
  );

  console.log('>>>>>>>>>>>>>>>>>>>>>> Fetch From Youtube');

  const data = await res.json();
  const items = data.items || [];

  const videoIds = items
    .map(item => item.snippet?.resourceId?.videoId)
    .filter(Boolean);

  if (videoIds.length === 0) return [];

  const durations = await fetchVideoDurations(videoIds);

  const longFormVideos = items.filter(item => {
    const id = item.snippet?.resourceId?.videoId;
    const duration = durations[id];
    return duration !== undefined && duration > SHORTS_MAX_DURATION_SECONDS;
  });

  return longFormVideos.slice(0, limit);
};

// ✅ NEW: fetch channel stats
export const fetchChannelStats = async (channelId) => {
  const res = await fetch(
    `https://www.googleapis.com/youtube/v3/channels?part=statistics&id=${channelId}&key=${API_KEY}`
  );

  console.log('fetched from yt');

  const data = await res.json();
  const stats = data.items?.[0]?.statistics;

  if (!stats) return null;

  return {
    subscribers: Number(stats.subscriberCount),
    videoCount: Number(stats.videoCount),
    views: Number(stats.viewCount),
  };
};